import shallowProperty from './_shallowProperty.js';

// Internal helper to obtain the `byteLength` property of an object.
export default shallowProperty('byteLength');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_getByteLength.js
// module id = 28
// module chunks = 3